/*
 * action types
 */

export const GROWLER__SHOW = 'GROWLER__SHOW';
export const GROWLER__HIDE = 'GROWLER__HIDE';
export const GROWLER__ABORT = 'GROWLER__ABORT';



// WEBPACK FOOTER //
// ./src/containers/Notification/constants.js